webpackJsonp([114276838955818,60335399758886],{

/***/ 196:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Buoy Health: Check Symptoms & Find the Right Care","description":"Check your symptoms and clarify your options for care. The Buoy A.I. health assistant guides you on your way to well, the moment you feel sick.","symptomCheckerPath":"symptom-checker/","mainImagePath":"images/"}}},"layoutContext":{}}

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(375);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(196);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  html {\n    box-sizing: border-box;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  body {\n    font-family: \"Roboto\", Arial, Helvetica, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 0;\n    margin: 0;\n    letter-spacing: 0.2px;\n  }\n"], ["\n  html {\n    box-sizing: border-box;\n  }\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n  body {\n    font-family: \"Roboto\", Arial, Helvetica, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    padding: 0;\n    margin: 0;\n    letter-spacing: 0.2px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _buoyTheme = __webpack_require__(4);
	
	var _buoyTheme2 = _interopRequireDefault(_buoyTheme);
	
	var _brands = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject);
	
	// Hacky redirect before page even loads for NYT
	var subdomain = (0, _brands.getSubdomain)();
	var useDashboard = subdomain === "nyt" || subdomain === "houstonmethodist";
	if (typeof window !== "undefined" && useDashboard && window.location.pathname === "/") {
	  window.location.replace("/dashboard/");
	}
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _buoyTheme2.default },
	    _react2.default.createElement(
	      "div",
	      null,
	      children()
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = Layout;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-17966540471b4ff86ba0.js